<template>
  <v-text-field
      ref="inputRef"
      type="text"
      inputmode="decimal"
      autocomplete="off"
      :label="label"
      :disabled="disabled"
      required
      outlined
      dense
      color="primary"
      class="input-field"
      :class="{'input-field-large': large}"
      :rules="rules"
      @blur="onBlur"
  ></v-text-field>
</template>

<script>
import {useCurrencyInput} from "vue-currency-input";
import {watch} from "@vue/composition-api";

export default {
  name: "CurrencyInput",
  props: {
    modelValue: Number,
    options: Object,
    rules: Array,
    label: String,
    value: Number | String,
    disabled: false,
    large: false
  },
  setup(props, { emit }) {
    let _timeOut = null;
    const {inputRef, setValue, formattedValue} = useCurrencyInput(props.options);
    const emitValue = (raw) => {
      const _value = Number(String(raw || "").replace(/[$,.\s]/g, ""));
      if (!_value && _value !== 0) return;
      emit("update:modelValue", _value);
      emit("change", _value);
    };
    watch(() => props.value, () => setValue(props.value));
    watch(formattedValue, (value, oldValue) => {
      if (!oldValue) return;

      const _value = Number(value.replace(/[$,.\s]/g, ""))
      const _oldValue = Number(oldValue?.replace(/[$,.\s]/g, ""));

      if (!_value || _value === _oldValue) return;
      if (_timeOut) clearTimeout(_timeOut);
      _timeOut = setTimeout(() => {
        emitValue(value);
      }, 400)
    })
    const onBlur = () => {
      if (_timeOut) {
        clearTimeout(_timeOut);
        _timeOut = null;
      }
      emitValue(formattedValue && formattedValue.value);
      emit("blur", formattedValue && formattedValue.value);
    };
    return {inputRef, onBlur};
  },
};
</script>
<style lang="scss">
.input-field-large {
  input {
    font-size: 1.5em !important;
    max-height: 39px !important;
  }
}
</style>